"use strict";
// Copyright 2022 Fergal Daly <fergald@gmail.com>.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TcbMailchimp = void 0;
const temp = `

`;
const TEMPLATE = `
<!DOCTYPE html>

<head>
  <base target="_blank">
  <!-- Begin Mailchimp Signup Form -->
  <style type="text/css">
    /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
       We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
    #container {
      font-size: 14px;
      font-family: jura, sans-serif;
      width: var(--customElementWidth);
      text-align: center;
    }

    #mc_embed_signup {
      display: inline-block;
    }

    #mc-embedded-subscribe {
      background: #000000;
      color: white;
    }
  </style>
</head>
<div id="container">
  <div id="mc_embed_signup">
    <form action="https://okomedyaki.us16.list-manage.com/subscribe/post?u=12dcceb21fc0b23703546901d&amp;id=61e36c7fbe"
      method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank"
      novalidate>
      <div id="mc_embed_signup_scroll">
        <div class="mc-field-group">
          <input type="email" value="" placeholder="Email address" name="EMAIL" class="required email"
            id="mce-EMAIL"><input type="submit" value="Sign Up" name="subscribe" id="mc-embedded-subscribe"
            class="button">
        </div>
        <div hidden="true"><input type="hidden" name="tags" value="3491001"></div>
        <div id="mce-responses" class="clear foot">
          <div class="response" id="mce-error-response" style="display:none"></div>
          <div class="response" id="mce-success-response" style="display:none"></div>
        </div>
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text"
            name="b_12dcceb21fc0b23703546901d_61e36c7fbe" tabindex="-1" value=""></div>
      </div>
    </form>
  </div>
</div>
<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script>
<script
  type='text/javascript'>(function ($) { window.fnames = new Array(); window.ftypes = new Array(); fnames[0] = 'EMAIL'; ftypes[0] = 'email'; fnames[1] = 'FNAME'; ftypes[1] = 'text'; fnames[2] = 'LNAME'; ftypes[2] = 'text'; fnames[3] = 'BIRTHDAY'; ftypes[3] = 'birthday'; }(jQuery)); var $mcj = jQuery.noConflict(true);</script>
<!--End mc_embed_signup-->
`;
class TcbMailchimp extends HTMLElement {
    constructor() {
        super();
        this.root = this.attachShadow({ mode: 'open' });
        this.root.innerHTML = TEMPLATE;
    }
}
exports.TcbMailchimp = TcbMailchimp;
window.customElements.define('tcb-mailchimp', TcbMailchimp);
